import { render, staticRenderFns } from "./SafetyLianxiDialog.vue?vue&type=template&id=1cc6730e&scoped=true&"
import script from "./SafetyLianxiDialog.vue?vue&type=script&lang=js&"
export * from "./SafetyLianxiDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6730e",
  null
  
)

export default component.exports